import { DatePipe, isPlatformBrowser } from '@angular/common';
import {
    Component,
    Inject,
    Input,
    OnInit,
    PLATFORM_ID
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Certificate } from 'src/app/construct-x/wallet/models/certificate';
import { DialogCertificateDetailComponent, DialogCertificateDetailData } from 'src/app/construct-x/shared/components/dialogs/dialog-certificate-detail/dialog-certificate-detail.component';
import { CertificateService } from 'src/app/construct-x/wallet/services/certificate.service';
import { DataType } from 'src/app/model/data-type.enum';
import { DisplayItemInterface } from 'src/app/model/marketplace/display-item-interface';
import { OrganisationInterface } from 'src/app/model/organisations/organisation-interface';
import { NavbarService } from 'src/app/services/componentServices/navbar-service/navbar-service';
import { OrganisationService } from 'src/app/services/dataServices/organisation-service/organisationservice';
import { DialogService } from 'src/app/services/dialog-service/dialog-service.service';
import { ProductlistService } from 'src/app/services/productlist-service/productlist.service';
import { UserService } from 'src/app/services/user-service/userservice';
import { environment } from 'src/environments/environment';
import { CertNode } from 'src/app/construct-x/wallet/models/cert-node';

@Component({
    selector: 'app-display-item',
    templateUrl: './display-item.component.html',
    styleUrls: ['./display-item.component.scss'],
    standalone: false
})
export class DisplayItemComponent implements OnInit {
    @Input()
    itemInfo: DisplayItemInterface;

    public organisation: OrganisationInterface;

    bgColors = [
        'var(--app-primary)',
        'var(--app-primary)',
        'var(--app-primary)',
        'var(--app-primary)',
        'var(--app-primary)',
        'var(--app-primary)',
        'var(--app-primary)',
        'var(--app-warn)',
        'var(--app-primary)'
    ];

    randomBgColor =
        this.bgColors[Math.floor(Math.random() * this.bgColors.length)];

    hover = false;
    @Input() focus = false;
    @Input() isProduct = true;
    @Input() isProvider = false;
    @Input() isCertification = false;
    @Input() bookmarked = false;
    certificationTooltip = 'Zertifikat für BIMSWARM Partnership';
    certificationImageUrl = environment.partnerCert;
    public enterprise: boolean = false;
    certificates: Certificate[] = [];
    private readonly isBrowser: boolean;



    get isPrioritized(): boolean {
        return this.itemInfo.displayType === 'PRODUCT' && this.itemInfo.prioritized === true;
    }

    get isSharePoint(): boolean {
        return this.itemInfo.properties?.webUrl?.includes('sharepoint.com');
    }

    get isDataOffer(): boolean {
        return !!this.itemInfo.properties;
    }

    get isFolder(): boolean {
        const props = this.itemInfo.properties;
        if (!props) return false;
        return props.isFolder === 'true' || props.isFolder === true || props.contenttype === 'application/vnd.folder' || props.contentType === 'application/vnd.folder';
    }

    getContentTypeIcon(): string {
        if (!this.itemInfo.properties) return 'insert_drive_file';
        const contentType = this.itemInfo.properties.contenttype || this.itemInfo.properties.contentType || '';
        if (this.isFolder) return 'folder';

        if (contentType.includes('pdf')) return 'picture_as_pdf';
        if (contentType.includes('image')) return 'image';
        if (contentType.includes('word') || contentType.includes('office')) return 'description';
        if (contentType.includes('excel') || contentType.includes('spreadsheet')) return 'table_view';
        if (contentType.includes('zip') || contentType.includes('archive')) return 'compress';
        if (contentType.includes('json') || contentType.includes('javascript')) return 'code';
        if (contentType.includes('text')) return 'article';

        return 'insert_drive_file';
    }

    get totalCertificateCount(): number {
        if (!this.itemInfo) return 0;
        return (
            (this.itemInfo.attributeCertificationCount || 0) +
            (this.itemInfo.ptgCertificationCount || 0) +
            (this.itemInfo.toolchainCertificationCount || 0)
            //   (this.itemInfo.ptgsWhereAllMandatoryAttributesImplementedCount || 0)
        );
    }

    constructor(
        private organisationService: OrganisationService,
        private userService: UserService,
        private productListService: ProductlistService,
        private dialogService: DialogService,
        private navbarService: NavbarService,
        private certificateService: CertificateService,
        private datePipe: DatePipe,
        private dialog: MatDialog,
        @Inject(PLATFORM_ID) platformId: object
    ) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    ngOnInit() {
        if (this.isBrowser) {
            document.documentElement.style.setProperty('--visibleLines', '5');
            document.documentElement.style.setProperty('--visibleLinesOrg', '7');
            document.documentElement.style.setProperty('--visibleLinesCert', '7');
            document.documentElement.style.setProperty('--visibleLinesNoCert', '5');
        }

        if (this.isCertification) {
            this.isProduct = false;
            this.isProvider = false;
            this.organisationService
                .getOrganisation(this.itemInfo.organisationId)
                .then((x) => {
                    this.organisation = x;
                });
        } else if (this.isProvider) {
            this.isProduct = false;
            this.isCertification = false;
        } else if (this.isProduct) {
            this.isCertification = false;
            this.isProvider = false;
            this.organisationService
                .getOrganisation(this.itemInfo.organisationId)
                .then((x) => {
                    this.organisation = x;
                });
            this.enterprise = this.itemInfo?.listingPkgName === 'Enterprise';
        } else {
            this.isProvider = false;
            this.isCertification = false;
            this.isProduct = true;
        }

        // Improve this by using the backend
        if (this.isProvider) {
            this.certificateService.getCertificates(this.itemInfo.id).subscribe(res => {
                if (res.message === "success")
                    this.certificates = res.value.filter(certificate => certificate.getShowInOrgCard());
                else console.error("The certificates of the organization could not be loaded. Error: " + res.message);
            });
        }
    }



    toggleProductInList(productId: number) {
        if (this.bookmarked) {
            if (this.itemInfo.displayType === DataType.CERTIFICATION) {
                this.removeProductFromList(productId, 0);
            } else if (this.itemInfo.displayType === DataType.PRODUCT) {
                this.removeProductFromList(productId, 1);
            } else if (this.itemInfo.displayType === DataType.ORGANISATION) {
                this.removeProductFromList(productId, 2);
            }
        } else {
            if (this.itemInfo.displayType === DataType.CERTIFICATION) {
                this.addToProductList(productId, 0);
            } else if (this.itemInfo.displayType === DataType.PRODUCT) {
                this.addToProductList(productId, 1);
            } else if (this.itemInfo.displayType === DataType.ORGANISATION) {
                this.addToProductList(productId, 2);
            }
        }
    }

    public hasCertification(): boolean {
        if (
            this.itemInfo.attributeCertificationCount > 0 ||
            this.itemInfo.ptgCertificationCount > 0 ||
            this.itemInfo.toolchainCertificationCount > 0
        ) {
            return true;
        }
        return false;
    }

    addToProductList(productId: number, displayType: number): void {
        this.productListService
            .addElementToList(productId, displayType)
            .subscribe(() => {
                if (displayType === 1) {
                    this.dialogService
                        .openDialog(
                            'Das Produkt wurde zu Ihrer Merkliste hinzugefügt',
                            ''
                        )
                        .subscribe(() => {
                            this.productListService.getAllProducts();
                        });
                } else if (displayType === 0) {
                    this.dialogService
                        .openDialog(
                            'Die Zertifizierung wurde zu Ihrer Merkliste hinzugefügt',
                            ''
                        )
                        .subscribe(() => {
                            this.productListService.getAllProducts();
                        });
                } else if (displayType === 2) {
                    this.dialogService
                        .openDialog(
                            'Der Anbieter wurde zu Ihrer Merkliste hinzugefügt',
                            ''
                        )
                        .subscribe(() => {
                            this.productListService.getAllProducts();
                        });
                }
                if (!this.navbarService.NAV_STATE_MY_PRODUCTS_LIST) {
                    this.navbarService.NAV_STATE_MY_PRODUCTS_LIST = true;
                    this.navbarService.loadButtons();
                }
            });
    }

    getCertificateTooltip(cert: Certificate): string {
        let lines = [
            cert.getName(),
            `Zertifizierer: ${cert.getIssuer() || '–'}`,
            `Ausstellungsdatum: ${this.formatCertDate(cert.getCreatedAt())}`,
            `Gültig bis: ${this.formatCertDate(cert.getValidUntil())}`
        ];
        return lines.join('\n');
    }

    openCertificateDetail(certificate: Certificate, $event: Event): void {
        $event.stopPropagation();
        let treeData = certificate.getTreeData();
        let certKeys = [{ key: "name", separator: ": " }, { key: "value", separator: "" }];
        let data: DialogCertificateDetailData = {
            title: certificate.getName(),
            treeData: treeData || [],
            certKeys
        };
        this.dialog.open(DialogCertificateDetailComponent, {
            width: '50vw',
            maxWidth: '60vw',
            data
        });
    }

    private removeProductFromList(
        productId: number,
        displayType: number
    ): void {
        this.productListService
            .deleteElementFromList(productId, displayType)
            .subscribe(() => {
                if (displayType === 0) {
                    this.dialogService
                        .openDialog(
                            'Die Zertifizierung wurde von Ihrer Merkliste',
                            ''
                        )
                        .subscribe(() => {
                            this.productListService.getAllProducts();
                        });
                }
                if (displayType === 1) {
                    this.dialogService
                        .openDialog(
                            'Das Produkt wurde von Ihrer Merkliste entfernt',
                            ''
                        )
                        .subscribe(() => {
                            this.productListService.getAllProducts();
                        });
                }
                if (displayType === 2) {
                    this.dialogService
                        .openDialog(
                            'Der Anbieter wurde von Ihrer Merkliste entfernt',
                            ''
                        )
                        .subscribe(() => {
                            this.productListService.getAllProducts();
                        });
                }
            });
    }

    isLoggedIn(): boolean {
        return this.userService.loggedIn;
    }

    removeEnters(): string {
        const description = this.itemInfo.description || this.itemInfo.properties?.dataDescription || this.itemInfo.properties?.DataDesc || '';
        return this.toPlainText(description);
    }

    removeEntersAssets(): string {
        const description = this.itemInfo.properties?.dataDescription || this.itemInfo.properties?.DataDesc || '';
        return this.toPlainText(description);
    }

    bookmark(event: Event) {
        event.stopPropagation();
        this.bookmarked = !this.bookmarked;
    }

    private formatCertDate(isoDate: string): string {
        if (!isoDate) return '–';
        let date = new Date(isoDate);
        if (isNaN(date.getTime())) return isoDate;
        return this.datePipe.transform(date, 'dd.MM.yyyy HH:mm') ?? isoDate;
    }

    private toPlainText(value: string): string {
        let htmlWithLineBreaks = value
            .replace(/<\/(p|li|ul|ol|div|br)\s*>/gi, '\n')
            .replace(/<(p|li|ul|ol|div|br)(\s[^>]*)?>/gi, ' ');
        let parsed = new DOMParser().parseFromString(htmlWithLineBreaks, 'text/html');
        return (parsed.body.textContent || '')
            .replace(/\u00A0/g, ' ')
            .replace(/[ \t]+\n/g, '\n')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
    }
}
